import { baseURL } from '@/httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';
const baseCenterURL = `${baseURL}/grt-user-center-service`;

export function getTenantConfigReq() {
    return hMacAjax.get(baseCenterURL + '/user/business/open/appName/v1/getConfig');
}

export function getObsTokenReq() {
    return hMacAjax.get(baseCenterURL + '/open/aliyun/oss/v1/temp/token');
}
